export type AppEnvironment = 'preview' | 'dev' | 'staging' | 'production';

const APP_ENVIRONMENTS: AppEnvironment[] = ['preview', 'dev', 'staging', 'production'];

export const DEPLOY_ENVIRONMENT_BAR_COLORS: Record<
  Exclude<AppEnvironment, 'production'>,
  string
> = {
  dev: '#22c55e',
  staging: '#eab308',
  preview: '#a855f7',
};

export function resolveBuildRevision(): string {
  const raw = process.env.NEXT_PUBLIC_BUILD_REVISION?.trim() ?? '';

  if (/^[0-9a-f]{40}$/i.test(raw)) {
    return raw.slice(0, 7);
  }

  return raw;
}

export function resolveAppEnvironment(): AppEnvironment {
  const raw = process.env.NEXT_PUBLIC_APP_ENV?.trim().toLowerCase();

  if (raw === 'prod') {
    return 'production';
  }

  if (raw === 'development') {
    return 'dev';
  }

  if (raw && APP_ENVIRONMENTS.includes(raw as AppEnvironment)) {
    return raw as AppEnvironment;
  }

  if (process.env.NODE_ENV === 'development') {
    return 'dev';
  }

  return 'production';
}

export function formatAppVersionLabel(
  version: string,
  appEnvironment: AppEnvironment,
  buildRevision = ''
): string {
  if (appEnvironment === 'production') {
    return `v${version}`;
  }

  const parts = [`v${version}`];
  const revision = buildRevision.trim();
  const showRevision = revision && (appEnvironment === 'dev' || appEnvironment === 'preview');

  if (showRevision) {
    parts.push(revision);
  }

  parts.push(appEnvironment);

  return parts.join(' · ');
}
